import React, { FC } from 'react';
import MessageInput from '~ComponentsImproved/MessageInput';
import { useDispatch, useI18n } from '~Hooks';
import * as actions from '~actions';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface Props {
  defaultEmail?: string;
  onSubmit: (email: string) => void;
}

/** Asks the user which email address the receipt should be sent to. */
const EmailReceiptModal: FC<Props> = ({ defaultEmail, onSubmit }) => {
  const { i18n } = useI18n();
  const dispatch = useDispatch();

  const handleSubmit = (value: string) => {
    const email = value.trim();

    if (!EMAIL_REGEX.test(email)) {
      dispatch(actions.addToast(i18n('Receipt.InvalidEmail'), true));
      return;
    }

    onSubmit(email);
  };

  return (
    <MessageInput
      type="text"
      value={defaultEmail ?? ''}
      autoFocus
      placeHolder={i18n('Receipt.EmailPlaceholder')}
      onSubmit={handleSubmit}
    />
  );
};

export default EmailReceiptModal;
